import { create } from 'zustand';

const useDigitalSignature = create((set) => ({
  signatureUrl: null, // Initial state
  setSignatureUrl: (value) => set({ signatureUrl: value }), // Function to update checked state
}));

export default useDigitalSignature;
